<template>
  <div
    class="custom-content"
    v-if="json"
    v-html="renderHtmlFromEditorJS(json)"
    v-bind="$attrs"
    v-on="$listeners"
  ></div>
  <div
    class="custom-content"
    v-else
    v-html="sanitize(html)"
    v-bind="$attrs"
    v-on="$listeners"
  ></div>
</template>

<script>
import { renderHtmlFromEditorJS } from '../../../core/utils/utils';
import { sanitize } from '@/core/utils/utils';

export default {
  name: 'HMCustomContent',
  props: {
    html: {
      type: String,
    },
    json: {
      type: String,
    },
  },
  methods: {
    renderHtmlFromEditorJS: renderHtmlFromEditorJS,
    sanitize,
  },
};
</script>

<style lang="scss" scoped></style>
